const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

const TODAY = "TODAY"

const getMonth = date => {
  const monthIndex = new Date(Date.parse(date)).getMonth()

  return monthNames[monthIndex]
}

const getYear = date => {
  const inputYear = new Date(Date.parse(date)).getFullYear()
  const todayYear = new Date().getFullYear()

  if (todayYear - inputYear >= 0) {
    return inputYear
  } else {
    return TODAY
  }
}

export const getMonthAndYear = date => {
  const month = getMonth(date)
  const year = getYear(date)

  if (year === TODAY) {
    return "Currently"
  } else {
    return `${month} ${year}`
  }
}
